// @flow

import _ from 'lodash';
import React from 'react';

import { Tracking } from 'web-core/src/tracking';
import { ExtoleReferralSimpleButtonCard } from 'client/components/extole/extoleReferralSimpleButtonCard';

type NavLinkType = {
  event: string,
  eventProps: string,
  link: string,
  shouldAlwaysDisplay: boolean,
  text: string,
};

type Props = {
  commonTranslations: TranslationType,
  isLoggedIn: boolean,
  isPartner: boolean,
  logout: Function,
  navlinks: string, // JSON pass from pug. convert navLinks to navlinks
};

const HomeNav = (props: Props) => {
  const { commonTranslations, isLoggedIn, isPartner, logout } = props;
  const navLinks: Array<NavLinkType> = JSON.parse(props.navlinks);

  const logNavItemClick = (eventName, property) => {
    Tracking.track(eventName, JSON.parse(property));
  };

  const renderNavListItems = () =>
    _.map(navLinks, (navLink) => {
      if (isPartner && navLink.shouldAlwaysDisplay === false) return null;
      return (
        <li key={navLink.text} className="hide-for-medium-down">
          <a href={navLink.link} onClick={() => logNavItemClick(navLink.event, navLink.eventProps)}>
            {navLink.text}
          </a>
        </li>
      );
    });

  const handleLogout = (e) => {
    e.preventDefault();
    logout().then(() => {
      window.location.href = '/';
    });
  };

  const renderLoginOrLogout = () => {
    if (isLoggedIn) {
      return (
        <li key={commonTranslations.logout}>
          <a href="/" className="logout" onClick={handleLogout}>
            <span className="log-in-and-log-out">{commonTranslations.logout}</span>
          </a>
        </li>
      );
    }
    return (
      <li key={commonTranslations.login}>
        <a href="/login">
          <span className="log-in-and-log-out">{commonTranslations.login}</span>
        </a>
      </li>
    );
  };

  return (
    <nav id="site-header-nav">
      <ul className="inline-block-list small-text-center medium-text-right">
        <li id="ExtoleHeaderReferralLink" key="ExtoleHeaderReferralLink">
          <ExtoleReferralSimpleButtonCard location="header" />
        </li>
        {renderNavListItems()}
        {renderLoginOrLogout()}
      </ul>
    </nav>
  );
};

export default HomeNav;
